import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import BASE_URL from "../Config/apiConfig";
import { Link } from "react-router-dom";
import { useCart } from "../Context/CartContext";
import { FaHeart, FaStar } from "react-icons/fa";

const Shop = () => {
  const [products, setProducts] = useState([]);
  const [sortedProducts, setSortedProducts] = useState([]);
  const [sortOrder, setSortOrder] = useState("");
  const [categories, setCategories] = useState([]);
  const [selectedMainCategory, setSelectedMainCategory] = useState("all");
  const { addToCart } = useContext(useCart);

  // Fetch all products
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/getAllProduct`);
        const result = response.data.result || [];
        setProducts(result);
        setSortedProducts(result);
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };

    fetchProducts();
  }, []);

  // Fetch categories
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/getcategory`);
        setCategories(response.data.result || []);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    fetchCategories();
  }, []);

  // Sort handler
  const handleSortChange = (e) => {
    const order = e.target.value;
    setSortOrder(order);

    let sorted = [...products];
    if (order === "lowToHigh") {
      sorted.sort((a, b) => a.price - b.price);
    } else if (order === "highToLow") {
      sorted.sort((a, b) => b.price - a.price);
    }

    setSortedProducts(sorted);
  };

  // Filter products by selected main category
  const filteredProducts = sortedProducts.filter((product) =>
    selectedMainCategory === "all"
      ? true
      : product.MaincategoryName === selectedMainCategory
  );

  return (
    <div style={{ padding: "60px 20px", background: "#fff" }}>
      <div style={{ maxWidth: "1300px", margin: "0 auto" }}>
        

        {/* Filters */}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "20px",
            marginBottom: "20px",
          }}
        >
          {/* Main Category Filter */}
          <div>
            <label style={{ marginRight: "10px", fontWeight: "600" }}>
              Filter by Main Category:
            </label>
            <select
              value={selectedMainCategory}
              onChange={(e) => setSelectedMainCategory(e.target.value)}
              style={{
                padding: "8px 12px",
                fontSize: "14px",
                borderRadius: "6px",
                border: "1px solid #ccc",
                outline: "none",
                cursor: "pointer",
              }}
            >
              <option value="all">All</option>
              {categories.map((cat) => (
                <option key={cat._id} value={cat.MaincategoryName}>
                  {cat.MaincategoryName}
                </option>
              ))}
            </select>
          </div>

          {/* Price Sort Filter */}
          <div>
            <label style={{ marginRight: "10px", fontWeight: "600" }}>
              Sort by Price:
            </label>
            <select
              value={sortOrder}
              onChange={handleSortChange}
              style={{
                padding: "8px 12px",
                fontSize: "14px",
                borderRadius: "6px",
                border: "1px solid #ccc",
                outline: "none",
                cursor: "pointer",
              }}
            >
              <option value="">Select</option>
              <option value="lowToHigh">Low to High</option>
              <option value="highToLow">High to Low</option>
            </select>
          </div>
        </div>

        {/* Product Grid */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(240px, 1fr))",
            gap: "20px",
          }}
        >
          {filteredProducts.map((product) => {
            const discountPercent = product.discountPrice
              ? Math.round(
                  ((product.discountPrice - product.price) /
                    product.discountPrice) *
                    100
                )
              : null;

            return (
              <div className="mt-5"
                key={product._id}
                style={{
                  background: "#ffffff",
                  borderRadius: "16px",
                  padding: "20px",
                  border: "1px solid #e0e0e0",
                  textAlign: "center",
                  position: "relative",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  transition: "transform 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-6px)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                }}
              >
                {/* Rating */}
                <div
                  style={{
                    position: "absolute",
                    top: "10px",
                    left: "10px",
                    backgroundColor: "#fdf5e6",
                    padding: "4px 10px",
                    borderRadius: "20px",
                    fontSize: "12px",
                    color: "#f9a825",
                    fontWeight: "600",
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                  }}
                >
                  <FaStar /> {product.rating || 4.5}
                </div>

                {/* Wishlist Icon */}
                <div
                  style={{
                    position: "absolute",
                    top: "10px",
                    right: "10px",
                    fontSize: "16px",
                    color: "#ccc",
                  }}
                >
                  <FaHeart />
                </div>

                {/* Product Image */}
                <Link to={`/product/${product._id}`}>
                  <img
                    src={`${BASE_URL}/uploads/${product.pImg?.[0]}`}
                    alt={product.pName}
                    style={{
                      height: "140px",
                      objectFit: "contain",
                      margin: "30px auto 20px",
                    }}
                  />
                </Link>

                {/* Product Name */}
                <h3
                  style={{
                    fontSize: "16px",
                    fontWeight: "600",
                    color: "#333",
                    marginBottom: "10px",
                    minHeight: "45px",
                  }}
                >
                  {product.pName}
                </h3>

                {/* Pricing */}
                <div style={{ marginBottom: "6px" }}>
                  <span
                    style={{
                      fontSize: "18px",
                      fontWeight: "700",
                      color: "#212121",
                    }}
                  >
                    ₹{Number(product.price).toFixed(2)}
                  </span>
                  {product.discountPrice && (
                    <span
                      style={{
                        textDecoration: "line-through",
                        color: "#9e9e9e",
                        fontSize: "14px",
                        marginLeft: "8px",
                      }}
                    >
                      ₹{Number(product.discountPrice).toFixed(2)}
                    </span>
                  )}
                </div>

                {/* Discount Label */}
                {discountPercent && (
                  <div
                    style={{
                      fontSize: "13px",
                      fontWeight: "600",
                      color: "#43a047",
                      marginBottom: "12px",
                    }}
                  >
                    Save {Math.abs(discountPercent)}% off
                  </div>
                )}

                {/* View Details Button */}
                <Link to={`/product/${product._id}`}>
                  <button
                    style={{
                      backgroundColor: "#3A8DF5",
                      color: "#fff",
                      fontSize: "15px",
                      fontWeight: "600",
                      padding: "10px 14px",
                      border: "none",
                      borderRadius: "8px",
                      width: "100%",
                      cursor: "pointer",
                      transition: "background 0.3s",
                    }}
                  >
                    View Details
                  </button>
                </Link>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Shop;
